<template>

  <v-snackbar
    v-if="message"
    elevation="24"
    rounded="pill"
    location="top"
    v-model="message"
    :timeout="5000">
    {{ message }}
    <template v-slot:actions>
      <v-btn
        color="green"
        variant="text"
        @click="message = null">
        X
      </v-btn>
    </template>
  </v-snackbar>

  <v-card class="mx-auto ma-4" max-width="30em" width="90%">
<!--
    <v-container fluid >
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8">
          <v-img 
            src="/assets/logo.svg"
            cover />
        </v-col>
      </v-row>
    </v-container>

    <v-card-title align="center">
        <i18n-t keypath="app.name">
          <span>Login-Title</span>
        </i18n-t>
    </v-card-title>
-->
    <v-card-title align="center" class="ma-4">
        <h3>
        {{ t('login.title') }}
        </h3>
    </v-card-title>



    <v-card-text>

      <v-row align="center" justify="center" class="ma-2">

        <v-col cols="12" sm="12">
          <v-text-field clearable variant="outlined" v-model="username"
                        :label="$t('login.username')" :rules="[rules.required, rules.min4]"
                        @click:append-inner="showLoginTooltip = !showLoginTooltip"
                        hide-details="auto" append-inner-icon="mdi-information-variant-circle">
            <v-tooltip v-model="showLoginTooltip" location="top"
                       activator="parent"
                       :open-on-click="false"
                       :open-on-focus="false"
                       :closeOnContentClick="true"
                       :close-on-back="true"
                       :open-on-hover="true">
                <p v-html="$t('login.hint')"></p>
            </v-tooltip>
          </v-text-field>
        </v-col>
      </v-row>

      <v-row align="end" justify="end" class="mx-5">
          <a href="https://my.fuerstenberg-institut.de/login/?action=lostpassword" target="_blank">{{ $t('login.forgot_password')}}</a>
      </v-row>

      <v-row align="center" justify="center" class="mx-2">

        <v-col cols="12" sm="12">

          <v-text-field v-model="password"
            clearable
            variant="outlined"
            :label="$t('login.password')" 
            :rules="[rules.required, rules.min8]" 
            :type="showPass ? 'text' : 'password'" 
            v-on:keyup.enter="handleLogin"
            :append-inner-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
             @click:append-inner="showPass = !showPass">
          </v-text-field>

        </v-col>
      </v-row>


      <v-row align="center" justify="center" class="ma-2">
        <v-col cols="12" sm="12">
          <v-btn :disabled="loading" width="100vw"
            rounded="lg" size="large"
            color="button"
            @click="handleLogin">{{ $t('login.submit') }}
            <span
                v-show="loading"
                class="spinner-border spinner-border-sm"
              ></span>
          </v-btn>

        </v-col>

      </v-row>

      <v-row align="center" justify="center" class="ma-2">
        <v-col cols="12" sm="12">
          <div class="footertext">
              <i18n-t keypath="login.footerText" tag="div">
                  <template #email>
                      <a :href="'mailto:' + SUPPORT_EMAIL" target="_blank" rel="noopener noreferrer">
                          {{ SUPPORT_EMAIL }}
                      </a>
                  </template>
              </i18n-t>
          </div>
        </v-col>
      </v-row>
    </v-card-text>

  </v-card>

</template>

<script>

import { SUPPORT_EMAIL } from '@/utils/constants.ts';
import { useI18n } from 'vue-i18n'

  export default {

    setup() {
      const { t } = useI18n()
      const required =  value => !!value || t('app.required')
      const min8 = v => v.length >= 8 || t('app.min_characters', { count: '8' })
      const min4 = v => v.length >= 4 || t('app.min_characters', { count: '4' })
      return { t, rules: { required: required, min8: min8, min4: min4 }, SUPPORT_EMAIL };
    },

    data: () => ({
      loading: false,
      username: "",
      password: "",
      show: false,
      showPass: false,
      message: '',
      showLoginTooltip: false,
      
    }),

    methods: {
      handleLogin() {
        this.$store.dispatch("auth/login", { login: this.username, password: this.password }).then(() => {
          this.$router.push("/"); 
        },(error) => {
          this.loading = false;
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          }
        );
      },
    },

  }
</script>

<style scoped>

.footertext {
    font-family: "Nunito Sans SemiBold";
    font-size: 1rem;
}

h3 {
    font-family: "Nunito Sans ExtraBold";
    font-size: 1.2em;
}

</style>